import { useEffect, type Dispatch, type SetStateAction } from 'react';
import { notifications } from '@mantine/notifications';
import { toHebrewApiErrorMessage } from '../../../services/index/index.service';

/**
 * Architectural summary: Converts local POS error state into Hebrew toast
 * notifications and clears the error after showing it.
 */
export function usePosErrorNotification(
  error: string | null,
  setError: Dispatch<SetStateAction<string | null>>,
) {
  useEffect(() => {
    if (!error) {
      return;
    }

    notifications.show({
      id: 'pos-error',
      title: 'שגיאה',
      message: toHebrewApiErrorMessage(error),
      color: 'red',
      autoClose: 3000,
    });
    setError(null);
  }, [error, setError]);
}
